import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectMissionActiveReplica} from '../../../redux/reducers/privateStateReducer/selectors';
import {missionCloseReplica} from '../../../redux/actions';
import {MENU_SOUND_MANAGER} from '../../../scenes/MenuSoundManager';
import {REPLICA_SIDES} from '../../../configs/campaigns/missionFormat';
import './MissionReplica.css';

/**
 * Текст реплики персонажа — внутри контента футера, вместо тулбаров: пока
 * герой говорит, играть всё равно нельзя. Внизу — ссылка «Далее», которая
 * пропускает реплику и отдаёт ход дальше по сценарию миссии.
 *
 * Сам персонаж (картинка) рисуется отдельным слоем НАД футером, см.
 * MissionReplicaCharacter.
 */
const MissionReplicaContent = () => {
  const dispatch = useDispatch();
  const replica = useSelector(selectMissionActiveReplica);

  if (!replica) {
    return null;
  }

  const handleNext = () => {
    MENU_SOUND_MANAGER.playMenuButtonClick();
    dispatch(missionCloseReplica());
  };

  // Текст прижимается к той же стороне, где стоит персонаж
  const side = replica.side === REPLICA_SIDES.RIGHT ? REPLICA_SIDES.RIGHT : REPLICA_SIDES.LEFT;

  return (
    <div className={`mission-replica-content mission-replica-content_${side}`}>
      <div className={'mission-replica-text'}>{replica.text}</div>
      <button type={'button'} className={'mission-replica-next'} onClick={handleNext}>
        Далее
      </button>
    </div>
  );
};

export default MissionReplicaContent;
